import { Model } from "./model";

export class Notification extends Model {
    id: number;
    translation_key: string;
    values: string;
    icon: string;
    created: string;
    read?: string;
}


// WEBPACK FOOTER //
// ./src/models/notification.model.ts